import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import {
  IcAppsIcon,
  IcCommentsIcon,
  IcJewerlyIcon,
  IcNewsIcon,
  IcSpaceIcon,
  IcSupportIcon,
  IcExternalLink24Icon,
} from '@gem/icons';
import { IcCalendarIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';

import { Features } from 'APP/packages/features/Features';

import { NavigationTab } from './NavigationTab/NavigationTab';
import { SidebarPanelLogo } from './SidebarPanelLogo/SidebarPanelLogo';
import {
  ISidebarPanelNavigationPresenterParams,
  useSidebarPanelNavigationPresenter,
} from './SidebarPanelNavigation.presenter';
import styles from './SidebarPanelNavigation.styles.m.css';
import { SpaceBadge } from './SpaceBadge/SpaceBadge';
import { UnreadBadge } from './UnreadBadge/UnreadBadge';

type ISidebarPanelNavigationProps = ISidebarPanelNavigationPresenterParams;

export const SidebarPanelNavigation: FC<ISidebarPanelNavigationProps> = observer((props) => {
  const presenter = useSidebarPanelNavigationPresenter(props);
  const { t } = useTranslation();

  return (
    <div
      className={styles.container}
      data-test="groups-navigation"
    >
      <SidebarPanelLogo />

      <div className={styles.content}>
        <div className={styles.contentGroup}>
          {Features.isSpacesEnabled() && (
            <NavigationTab
              Icon={IcSpaceIcon}
              Badge={SpaceBadge}
              label={t('space_spaces')}
              isActive={presenter.isActiveSpaces}
              dataTest="spaces"
              onClick={presenter.setActiveSpaces}
            />
          )}

          <NavigationTab
            Icon={IcCommentsIcon}
            Badge={UnreadBadge}
            label={t('navigation_talks')}
            isActive={presenter.isActiveTalks}
            dataTest="talks"
            onClick={presenter.setActiveTalks}
          />

          {presenter.isCalendarEnabled && (
            <NavigationTab
              Icon={IcCalendarIcon}
              label={t('calendar')}
              isActive={presenter.isActiveCalendar}
              dataTest="calendar"
              onClick={presenter.setActiveCalendar}
            />
          )}
        </div>

        <div className={styles.contentGroup}>
          {presenter.isShowMarketplace && (
            <NavigationTab
              Icon={IcJewerlyIcon}
              label={t('common_hub')}
              onClick={presenter.openHub}
            />
          )}

          {Features.isNewsfeedEnabled() && (
            <NavigationTab
              Icon={IcNewsIcon}
              label={t('bottom_tabs_newsfeed')}
              onClick={presenter.openNewsfeed}
            />
          )}

          {Features.isCatalogEnabled() && (
            <NavigationTab
              Icon={IcAppsIcon}
              label={t('statistics_catalog')}
              onClick={presenter.openCatalog}
            />
          )}

          {presenter.isToAdminButtonShow && (
            <NavigationTab
              Icon={IcExternalLink24Icon}
              label={t('common_admin_panel')}
              onClick={presenter.openAdminPanel}
            />
          )}

          <NavigationTab
            Icon={IcSupportIcon}
            label={t('talks_support')}
            onClick={presenter.openSupport}
          />
        </div>
      </div>
    </div>
  );
});
